<template>
  <div>
    <form :class="$style.globalPolicyFormPosition">
      <DropDown
        :name="stateName"
        optionLabelKey="name"
        optionLabelValue="value"
        :options="policyOptions"
        :value="policyLabel"
        @input="handleActionChange"
      />
    </form>
    <span
      v-if="shouldShowError"
      :class="$style.errorText"
    >
      There was an error retrieving the Global Setting. Please refresh.
    </span>
  </div>
</template>

<script>
import { AuthnPolicyConsts } from 'client/util/Constants';
import { cloneDeep, find } from 'lodash';
import { getPolicyOptionsByStateName, simplePolicy } from 'client/Security/utils/AuthnPolicyUtilities';
import DropDown from 'client/components/FormValidation/DropDown.vue';

const { policyActions } = AuthnPolicyConsts;

export default {
  name: 'GlobalPolicySettingsPicker',

  components: {
    DropDown,
  },

  props: {
    stateName: {
      type: String,
      required: true,
    },
  },

  computed: {
    policy() {
      return this.$store.state[this.stateName].item;
    },

    policyLabel() {
      const { action } = simplePolicy(this.policy);
      const policy = find(this.policyOptions, option => option.value === action);

      return policy.name;
    },

    policyOptions() {
      return getPolicyOptionsByStateName(this.stateName);
    },

    shouldShowError() {
      return !this.policyLabel;
    },
  },

  async mounted() {
    await this.fetchItem();
  },

  methods: {
    fetchItem() {
      this.$store.dispatch(`${this.stateName}/fetchItem`);
    },

    handleActionChange(option) {
      const policyUpdate = cloneDeep(this.policy);

      policyUpdate.effect.action = option.value;

      if (option.value === policyActions.allow
      || option.value === policyActions.allowWithMFA) {
        policyUpdate.effect.obligations = option.obligations;
      } else {
        delete policyUpdate.effect.obligations;
      }

      this.updateItem(policyUpdate);
    },

    updateItem(value) {
      this.$store.dispatch(`${this.stateName}/updateItem`, value);
    },
  },
};
</script>

<style module>
  @import '../components/FormValidation/css/formFields.css';

  .errorText {
    color: var(--jcError700);
    display: block;
    font-size: 0.9em;
    margin-top: -1.25em;
  }

  .globalPolicyFormPosition {
    max-width: 28rem;
  }

  .globalPolicyFormPosition div {
    margin-top: 0.5rem;
  }
</style>
